import { cn } from '@wellesley/ui'
import { OctagonX } from 'lucide-react'
import { FC } from 'react'

const DeletedUser = () => (
  <div className="flex size-9 items-center justify-center rounded-full border border-gray-300 bg-gray-50">
    <OctagonX color="var(--gray-300)" size={15} />
  </div>
)

type TDeletedContent = {
  isRepostFeed?: boolean
}

const DeletedContent: FC<TDeletedContent> = ({ isRepostFeed }) => (
  <div
    className={cn('relative z-10 flex cursor-default items-center gap-2', {
      'p-s rounded-lg border border-gray-300': isRepostFeed,
    })}
    onClick={(evt: React.MouseEvent) => {
      evt.stopPropagation()
      evt.preventDefault()
    }}
  >
    <DeletedUser />
    <p className="text-sm text-gray-400">
      This content isn&apos;t available right now
    </p>
  </div>
)

export default DeletedContent
